import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";

import { Tooltip } from "@toddle-edu/ds-web";

import ConditionalWrapper from "Utils/ConditionalWrapper";

import StudentAlerts from "../StudentAlerts";
import classes from "./StudentAlertsWrapper.scss";

const StudentAlertsWrapper = props => {
  const {
    children,
    tooltip,
    className,
    style = {},
    containerClass,
    studentId,
    alertTypes,
    showAlertPopover,
    hideAlerts = false,
    iconProps,
    tooltipProps = {},
    shouldAutoFocusPopover,
    dir,
  } = props;

  const ref = useRef();
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    if (ref && ref.current) {
      const element = ref?.current;
      if (element.scrollWidth > element?.offsetWidth) {
        setShowTooltip(true);
      }
    }
  }, [children]);

  const containerClasses = classNames(
    containerClass,
    classes.studentAlertsWrapper
  );
  const childrenClasses = classNames(className, classes.textEllipsis);

  return (
    <div className={containerClasses}>
      {children && (
        <ConditionalWrapper
          type="wrapperAsElement"
          wrapper={<Tooltip tooltip={tooltip || children} {...tooltipProps} />}
          condition={showTooltip}
        >
          <div className={childrenClasses} style={style} dir={dir} ref={ref}>
            {children}
          </div>
        </ConditionalWrapper>
      )}
      {!hideAlerts ? (
        <StudentAlerts
          studentId={studentId}
          alertTypes={alertTypes}
          showAlertPopover={showAlertPopover}
          iconProps={iconProps}
          shouldAutoFocusPopover={shouldAutoFocusPopover}
        />
      ) : null}
    </div>
  );
};

export default StudentAlertsWrapper;
